export default __webpack_public_path__ + "static/media/user.b6949c6f.svg";